import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

export interface AppState {
  user: {
    profile?: UserDetail;
    impersonatedUser?: number | null;
  };
  google: {
    loaded?: boolean;
  };
  defaultLocation: DefaultProjectLocations;
}

const initialState: AppState = {
  user: {
    profile: null,
    impersonatedUser: null,
  },
  google: {
    loaded: false,
  },
  defaultLocation: null,
};

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setUserProfile: (state, action: PayloadAction<UserDetail>) => {
      state.user.profile = action.payload;
    },
    updateUserProfile: (state, action: PayloadAction<Partial<UserDetail>>) => {
      state.user.profile = { ...state.user.profile, ...action.payload };
    },
    clearUserProfile: (state) => {
      state.user.profile = null;
      state.user.impersonatedUser = null;
    },
    setGoogleMapsApiLoaded: (state, action: PayloadAction<boolean>) => {
      state.google.loaded = action.payload;
    },
    setImpersonatedUser: (state, action: PayloadAction<number | null>) => {
      state.user.impersonatedUser = action.payload;
    },
    setDefaultLocation: (
      state,
      action: PayloadAction<DefaultProjectLocations>
    ) => {
      state.defaultLocation = action.payload;
    },
  },
});

// actions to use with dispatch(getBookings())
export const {
  setUserProfile,
  clearUserProfile,
  setGoogleMapsApiLoaded,
  setImpersonatedUser,
  updateUserProfile,
  setDefaultLocation,
} = appSlice.actions;
export const { reducer } = appSlice; // use this to pass to combineReducers in upper levels
